import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'kt-task-skeleton',
  templateUrl: './task-skeleton.component.html',
  styleUrls: ['./task-skeleton.component.scss'],
})
export class TaskSkeletonComponent {
  constructor(private dialogRef: MatDialogRef<TaskSkeletonComponent>) {}

  close(event: Event, data?: any): void {
    event?.stopPropagation();

    this.dialogRef.close(data);
  }
}
